export enum CustomerType {
  SHIPPER = 'SHIPPER',
  CONSIGNEE = 'CONSIGNEE',
  SHIPPING_LINE = 'SHIPPING_LINE'
}
